<template>
  <div class="page-content conmon-top single-chart">
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4"
                class="search-nav-left">
          <i class="el-icon-search"
             style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="hide">收起查询</el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="!hide">展开查询</el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="search">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-content"
             style="padding: 0">
          <el-form :inline="true"
                   :model="formInlineTmp"
                   label-width="95px"
                   class="search-content-item common-search-formtype">
            <el-form-item label="文件名称：">
              <el-input @keyup.enter.native="search"
                        v-model.trim="formInlineTmp.name"
                        placeholder="请输入文件名称"
                        clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top"
            style="padding-right:0">
      <el-col :span="18"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span" v-for="(item,index) in breadcrumb" :key="index">
          <span class="breadcrumb" @click="goBreadcrumb(item.pid,item.router)"> {{item.fileName}} <span>></span> </span>
        </span>
      </el-col>
      <el-col :span="6"
              class="text-align-right">
        <el-row style="text-align: right;display: flex;flex-direction: row-reverse;">
          <el-col :span="4">
            <el-button type="primary" @click="creatFolder"
                      class="add-btn btn-right">
              新建
            </el-button>
          </el-col>
          <el-col :span="20" style="margin-right:50px;">
            <el-upload  style="height:40px;text-align:right;"
                        :action="uploadUrl"
                        :headers="uploadHeader"
                        :data="uploadData"
                        :before-upload="beforeUpload"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :on-progress="handleProgress"
                        name="file"
                        accept="file"
                        :show-file-list="false">
              <el-button type="primary" class="uploadBtn">上传</el-button>
            </el-upload>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style" v-if="tableData.length>0">
      <el-table :data="tableData"
                v-loading="loading" @cell-click="tableCellClick">
        <template slot="empty">
          <div class="newTableEmpty">暂无文件</div>
        </template>
        <el-table-column prop="fileName"
                         label="名称">
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间">
        </el-table-column>
        <el-table-column prop="fileSize" label="大小">
        </el-table-column>
        <el-table-column
                         label="操作"
                         style="display: flex;justify-content: center;">
          <template v-slot="scope">
            <div class="operation-link">
              <div class="op-link" v-if="scope.row.isDir===1"
                   @click="editFolder(scope.row.id)">
                管理
              </div>
              <div class="op-link editColor" v-if="scope.row.isDir===0"
                   @click="downLoad(scope.row.fullName,scope.row.id)">
                下载
              </div>
              <div class="op-link deleteColor"
                   @click="deleteRow(scope.row.id, scope.row.isDir)">
                删除
              </div>
              <div class="op-link" v-if="scope.row.isDir===0"
                   @click="toDetail(scope.row.id)">
                查看详情
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination"
                       background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
    <el-row v-else class="noList">
      <div class="text">暂无文件</div>
      <div>点击上传按钮开始上传文件，仅支持DOC、DOCX、PPTX、PPT、XLSX、XLS、PDF等格式，不支持压缩包和大型文件。</div>
      <div>
        <el-upload
                    :action="uploadUrl"
                    :headers="uploadHeader"
                    :data="uploadData"
                    :before-upload="beforeUpload"
                    :on-success="uploadSuccess"
                    :on-error="uploadError"
                    :on-progress="handleProgress"
                    name="file"
                    accept="file"
                    :show-file-list="false">
          <el-button type="primary" class="uploadBtn big">上传</el-button>
        </el-upload>
      </div>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="50%" @closed="dialogFormClosed">
      <el-form :model="dialogForm" :rules="dialogFormRules" ref="dialogFormRef" class="search-content-item">
        <el-form-item prop="fileName" label="文件夹名称：" label-width="120px">
          <el-input style="width:240px;" v-model="dialogForm.fileName" placeholder="请填写文件夹名称"></el-input>
        </el-form-item>
        <el-form-item label="权限管理：" label-width="120px">
          <el-radio-group v-model="dialogForm.radio">
            <el-radio :label="1">所有人可见</el-radio>
            <el-radio :label="2">指定人可见</el-radio>
          </el-radio-group>
          <el-row v-show="dialogForm.radio===2" style="width:90%;border:1px solid #eee;">
            <el-col :span="12" class="left-con">
              <div class="search">
                <el-input v-model="transferQuery" clearable placeholder="请输入姓名、用户名"></el-input>
                <el-button type="primary" @click="onSearch">搜索</el-button>
              </div>
              <el-table ref="tableRef" :data="leftData" style="margin:0 0 10px;height:360px;overflow-y:scroll;"
                    v-loading="transferLoading"
                    @select="handleSelectionChange"
                    :show-header="false">
                <template slot="empty">
                  <div class="newTableEmpty">暂无数据</div>
                </template>
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="name" width="60"></el-table-column>
                <el-table-column prop="username"></el-table-column>
              </el-table>
              <el-pagination
                style="width:220px;"
                hide-on-single-page="true"
                layout="prev, pager, next"
                :total="transferTotal"
                @size-change="transferSizeChange"
                @current-change="transferCurrentChange"
                :current-page.sync="transferPage"
                :page-size="transferLimit">
              </el-pagination>
            </el-col>
            <el-col :span="12" class="right-con">
              <div class="title-id">已选</div>
              <div class="select-arr">
                <div class="item" v-for="item in rightData" :key="item.id">
                  {{item.name}}
                  <i v-if="item.candel" class="el-icon-close" @click="delSelectItem(item.id)"></i>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="文件详情" :visible.sync="dialogTableVisible" width="40%">
      <el-table :data="dialogTableData"
                v-loading="dloading">
        <template slot="empty">
          <div class="newTableEmpty">暂无记录</div>
        </template>
        <el-table-column prop="createUserName"
                         label="操作人">
        </el-table-column>
        <el-table-column prop="createTime" label="操作时间">
        </el-table-column>
        <el-table-column label="操作类型">
          <template v-slot="scope">
            <span v-if="scope.row.type===1">查看</span>
            <span v-if="scope.row.type===2">下载</span>
            <span v-if="scope.row.type===3">上传</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination"
                       background
                       @size-change="dhandleSizeChange"
                       @current-change="dhandleCurrentChange"
                       :page-size="dlimit"
                       layout="total, prev, pager, next, jumper"
                       :total="dtotalCount">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryList, getUser, saveFile, updateFileInfo, delFile, getFileDetails, qiniuToken, saveFileInfo, delFileInfo, getFileInfo, recordDownLoad } from '@/api/cloudDisk.js'
import {getuuid,cleanString} from '@/utils/utils.js'
import Lockr from 'lockr'
export default {
  name: 'cloud-disk',
  data () {
    return {
      pid: '',
      fileName: '全部文件',
      uploadUrl: 'http://up-z0.qiniu.com',
      // 文件上传时额外的参数
      uploadData: {
        key: '',
        token: ''
      },
      // 导入中请稍后
      uploadDialogVisible: false,
      // progress 进度条 百分比
      uploadProgress: 0,
      uploadSetTimeout: '',
      loading: true,
      formInlineTmp: {
        name: ''
      },
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      butsObj: { // button按钮列表
        add: false,
        details: false,
        del: false
      },
      // 新建
      fileId: '',
      dialogTitle: '文件夹管理',
      dialogFormVisible: false,
      dialogForm: {
        fileName: '',
        radio: 1
      },
      dialogFormRules: {
        fileName: [{ required: true, message: '请填写文件夹名称', trigger: 'blur' }]
      },
      transferQuery: '',
      rightData: [],
      transferTotal: 0,
      leftData: [],
      transferPage: 1,
      transferLimit: 15,
      transferLoading: true,
      // 详情
      did: '',
      dialogTableVisible: false,
      dialogTableData: [],
      dloading: true,
      dpage: 1,
      dlimit: 10,
      dtotalCount: 0,
      breadcrumb: [{
        pid: 0,
        fileName: '全部文件',
        router: '/home/cloud-disk'
      }]
    }
  },
  watch: {
    'dialogForm.radio'(val) {
      if (val === 2) {
        this.getUserList()
        if (this.rightData.length === 0) {
          this.rightData = [{
            id: Lockr.get('userInfo').id,
            username: Lockr.get('userInfo').username,
            name: Lockr.get('userInfo').realname,
            candel: false
          }]
        }
      }
    },
    $route(to, from) {
      console.log(to, from)
      if (from) {
        let arr = JSON.parse(localStorage.getItem('cloudBreadcrumb'))
        let index = arr.findIndex(item => item.pid===parseInt(from.query.id))
        this.breadcrumb = arr.slice(0, index)
        console.log(this.breadcrumb, 'this.breadcrumb')
        localStorage.setItem('cloudBreadcrumb', JSON.stringify(this.breadcrumb))
        this.$router.push({
          path: '/home/cloud-disk-empty',
          query: {
            router: this.breadcrumb[this.breadcrumb.length-1].router
          }
        })
      }
    }
  },
  computed: {
    // 文件上传地址
    // uploadUrl () {
    //   return process.env.VUE_APP_YUNDIAN_API + 'salesman/potentialCustomersManage/importPotentialCustomersExcel'
    // },
    // 文件上传请求头部
    uploadHeader () {
      return {
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId')
      }
    }
  },
  methods: {
    getQiniuToken () {
      qiniuToken({}).then(res => {
        this.uploadData.token = res.data.result
      })
    },
    // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload (file) {
      // console.log(file, 'beforeUpload')
      
      this.uploadProgress = 0
      this.uploadDialogVisible = true
      // 处理七牛的key，增加随机数，过滤特殊字符
      this.uploadData.key = 'jinsha_doc/'+ getuuid(10) + '-' + cleanString(file.name);
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.')+1).toLowerCase()
      const whiteList = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"]
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.warning('上传文件格式不正确')
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过100M')
        return false
      }
    },
    // 文件上传成功时的钩子
    uploadSuccess (res, file) {
      console.log(res, file, 'Success')
      clearTimeout(this.uploadSetTimeout)
      this.uploadProgress = 100
      setTimeout(() => {
        this.uploadDialogVisible = false
      }, 500)
      // if (file.code == 200) {
      //   this.$message.success(file.result)
      //   this.getData()
      // } else {
      //   this.$message.error(file.msg)
      // }
      let params = {
        fileName: file.name,
        fullName: 'https://dmpsource.intelliquor.com/' + res.key,
        pid: this.pid,
        isDir: 0,
        size: file.size,
        type: 3 // 1 小程序预览 2 下载 3上传
      }
      saveFileInfo (params).then(res => {
        if (res.data.code === '200') {
          this.getData()
        }
      })
    },
    // 文件上传时钩子
    handleProgress (event, file) {
      // console.log(event, file, 'handleProgress')
      let filePercentage = parseInt(file.percentage)
      let uploadPercent = parseInt(event.percent - file.percentage)
      let oneTime = parseInt(event.total / 250)
      this.updatePercent(1, uploadPercent, filePercentage, oneTime)
    },
    updatePercent (i, uploadPercent, filePercentage, oneTime) { // 1 0 100 260
      if (i == 1) {
        clearTimeout(this.uploadSetTimeout)
      }
      let self = this
      if (i < uploadPercent) {
        this.uploadSetTimeout = setTimeout(() => {
          this.uploadProgress = parseInt(filePercentage + i)
          self.updatePercent(i + 1, uploadPercent, filePercentage, oneTime)
        }, oneTime)
      } else {
        clearTimeout(this.uploadSetTimeout)
      }
    },
    // 上传失败
    uploadError() {
      this.$message({
        message: "上传出错，请重试！",
        type: "error",
        center: true
      });
    },
    // 下载
    downLoad(fullName,id) {
      recordDownLoad({id}).then(res => {
        console.log(res)
      })
      window.location.href = fullName
    },
    // 点击单元格
    tableCellClick (row, column) {
      // console.log(row, column)
      if (column.property === 'fileName') {
        if (row.isDir === 1) {
          // this.$router.push(`/home/cloud-disk-detail?id=${row.id}&fileName=${row.fileName}`)
          this.$router.push({
            path: '/home/cloud-disk-empty',
            query: {
              router: `/home/cloud-disk-detail?id=${row.id}&fileName=${row.fileName}`
            }
          })
          this.breadcrumb = JSON.parse(localStorage.getItem('cloudBreadcrumb'))
          this.breadcrumb.push({
            pid: row.id,
            fileName: row.fileName,
            router: `/home/cloud-disk-detail?id=${row.id}&fileName=${row.fileName}`
          })
          localStorage.setItem('cloudBreadcrumb', JSON.stringify(this.breadcrumb))
        } else {
          window.location.href = row.fullName
        }
      }
    },
    // 点击面包屑
    goBreadcrumb (pid, path) {
      let arr = JSON.parse(localStorage.getItem('cloudBreadcrumb'))
      let index = arr.findIndex(item => item.pid===pid)
      this.breadcrumb = arr.slice(0, index+1)
      localStorage.setItem('cloudBreadcrumb', JSON.stringify(this.breadcrumb))

      this.$router.push({
        path: '/home/cloud-disk-empty',
        query: {
          router: path
        }
      })
    },
    search () {
      this.getData()
    },
    // 获取列表
    getData () {
      this.loading = true
      let params = {
        pid: this.pid || this.$route.query.id,
        page: this.page,
        limit: this.limit,
        name: this.formInlineTmp.name
      }
      queryList(params).then(res => {
        if (res.data.code === '200') {
          this.tableData = res.data.result.list
          this.totalCount = res.data.result.total
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 列表处理分页
    handleSizeChange (val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange (page) {
      this.page = page
      this.getData()
    },
    // 用户列表
    getUserList () {
      this.leftData = []
      let params = {
        page: this.transferPage,
        limit: this.transferLimit,
        name: this.transferQuery
      }
      getUser(params).then(res => {
        this.transferLoading = false
        if (res.data.code === '200') {
          this.transferTotal = res.data.result.total
          res.data.result.list.forEach(item => {
            this.leftData.push({
              id: item.id,
              username: item.username,
              name: item.realname,
              candel: true
            })
          })
          // 选中指定人回显
          if (this.dialogForm.radio===2 && this.rightData.length>0) {
            this.$nextTick(() => {
              // 获取选中项
              const selectedArr = this.rightData.map(item=>item.id)
              // 获取到leftData包含selectedArr的id项
              const list = this.leftData.filter(item => {
                return selectedArr.includes(item.id)
              })
              // console.log(list, 'list')
              // 将获取到的行反选
              list.forEach(item => {
                this.$refs.tableRef.toggleRowSelection(item)
              })
            })
          }
        }
      })
    },
    onSearch () {
      this.getUserList()
    },
    // 用户列表表格多选
    handleSelectionChange (val, row) {
      // 勾掉复选框删除右侧一项数据
      this.leftData.forEach(item => {
        this.rightData = this.rightData.filter(item=>item.id!==row.id)
      })

      const proList = this.rightData.concat(val)
      //去除重复数据
      const obj = {}
      const newProList = proList.reduce((cur, next) => {
        obj[next.id] ? '' : obj[next.id] = true && cur.push(next)
        return cur
      }, [])
      this.rightData = newProList
    },
    // 删除已选项
    delSelectItem (id) {
      // 获取到删除的某一项
      const selectedArr = this.rightData.filter(item=>item.id===id)
      // 匹配到表格数据里删除的某一项
      const list = this.leftData.filter(item => {
        return selectedArr.some(ele => item.id === ele.id)
      })
      // 将删除的某一项反选
      list.forEach(item => {
        this.$refs.tableRef.toggleRowSelection(item)
      })
      // 右侧数据删除某一项
      this.rightData = this.rightData.filter(item=>item.id!==id)
    },
    // 获取文件夹详情
    getFileDetails (id) {
      getFileDetails({id}).then(res => {
        let data = res.data
        if (data.code === '200') {
          this.dialogForm.fileName = data.result.fileName
          this.dialogForm.radio = data.result.permissions
          data.result.permissionsList.forEach(item => {
            if (item.id == Lockr.get('userInfo').id) {
              item['candel'] = false
            } else {
              item['candel'] = true
            }
          })
          this.rightData = data.result.permissionsList

          // 选中指定人回显---在这里回显翻页会清空选中
          // if (data.result.permissions===2 && data.result.permissionsList.length>0) {
          //   this.$nextTick(() => {
          //     // 获取选中项
          //     const selectedArr = this.rightData.map(item=>item.id)
          //     // 获取到leftData包含selectedArr的id项
          //     const list = this.leftData.filter(item => {
          //       return selectedArr.includes(item.id)
          //     })
          //     // console.log(list, 'list')
          //     // 将获取到的行反选
          //     list.forEach(item => {
          //       this.$refs.tableRef.toggleRowSelection(item)
          //     })
          //   })
          // }
        }
      })
    },
    // 指定人列表分页
    transferSizeChange (val) {
      this.transferLimit = val
      this.transferLoading = true
      this.getUserList()
    },
    transferCurrentChange (page) {
      this.transferPage = page
      this.transferLoading = true
      this.getUserList()
    },
    creatFolder () {
      this.dialogTitle = '新建文件夹'
      this.dialogFormVisible = true
      this.fileId = ''
      // this.getUserList()
    },
    editFolder (id) {
      this.dialogTitle = '文件夹管理'
      this.dialogFormVisible = true
      this.fileId = id
      this.getFileDetails(id)
      // this.getUserList()
    },
    // 新建文件夹关闭时
    dialogFormClosed () {
      this.dialogForm.fileName = ''
      this.dialogForm.radio = 1
      this.transferPage = 1
      this.rightData = []
      this.transferQuery = ''
    },
    // 新建文件夹保存
    save () {
      let params = {
        fileName: this.dialogForm.fileName,
        pid: this.pid,
        isDir: 1,
        permissions: this.dialogForm.radio,
        permissionsList: [{
          type: 1,
          allowId: this.rightData.map(item=>item.id)
        }]
      }
      this.$refs.dialogFormRef.validate((valid) => {
        if (!valid) return
        if (!this.fileId) {
          params.fileId && delete params.fileId
          saveFile(params).then(res => {
            if (res.data.code === '200') {
              this.$message.success('新建文件夹成功')
              this.getData()
            } else {
              this.$message.error(res.data.message)
            }
            this.dialogFormVisible = false
          })
        } else {
          params.fileId = this.fileId
          updateFileInfo(params).then(res => {
            if (res.data.code === '200') {
              this.$message.success('更新文件夹成功')
              this.getData()
            } else {
              this.$message.error(res.data.message)
            }
            this.dialogFormVisible = false
          })
        }
      })
    },
    // 删除
    deleteRow (id, isDir) {
      this.$confirm('确认删除此条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (isDir === 1) {
          delFile({id}).then(res => {
            if (res.data.code === '200') {
              _g.toastMsg('success', res.data.message)
            } else {
              _g.toastMsg('error', res.data.message)
            }
            this.getData()
          })
        } else {
          delFileInfo({id}).then(res => {
            if (res.data.code === '200') {
              _g.toastMsg('success', res.data.message)
            } else {
              _g.toastMsg('error', res.data.message)
            }
            this.getData()
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 查看详情
    toDetail (id) {
      this.did = id
      this.dialogTableVisible = true
      this.getFileInfo()
    },
    getFileInfo () {
      this.dloading = true
      let params = {
        page: this.dpage,
        limit: this.dlimit,
        id: this.did
      }
      getFileInfo(params).then(res => {
        if (res.data.code === '200') {
          this.dialogTableData = res.data.result.list
          this.dtotalCount = res.data.result.total
        }
        this.dloading = false
      })
    },
    // 查看详情分页
    dhandleSizeChange (val) {
      this.dlimit = val
      this.getFileInfo()
    },
    dhandleCurrentChange (page) {
      this.dpage = page
      this.getFileInfo()
    },

    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res => {
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr = result.map((item) => {
            return item.perms
          })
          arrObj.map(it => {
            if (newarr.indexOf(it) !== -1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  mounted () {
    // this.getButtonsList()
    this.getData()
    this.getQiniuToken()
    this.pid = this.$route.query.id
    this.fileName = this.$route.query.fileName
    this.breadcrumb = JSON.parse(localStorage.getItem("cloudBreadcrumb"))
  }
}
</script>

<style scoped>
.search-content-item >>> .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label span{
  right: 10px!important;
}
.search-content-item >>> .el-button--primary {
  float: none;
}
.dialog-footer {
  text-align: center;
}
.dialog-footer >>> .el-button--default {
  border-radius: 2px;
}
.dialog-footer >>> .el-button--primary {
  float: none;
}
.uploadBtn {
  background: rgba(255, 153, 0, 1);
  border: rgba(255, 153, 0, 1);
}
.uploadBtn.big {
  padding: 20px 40px;
  border-radius:4px;
}
.noList {
  height: 60vh;
  background: #fff;
  margin: 0 24px;
  padding: 100px 0;
  font-size: 16px;
  color: #666;
}
.noList .text {
  font-weight: bold;
  font-size: 24px;
  color: #333;
}
.noList div {
  margin-bottom: 20px;
}


.left-con .search{
  display: flex;
  margin: 20px 10px;
}
.left-con .el-button--primary {
  margin-top: 0;
}
.right-con {
  padding: 20px;
  box-sizing: border-box;
}
.title-id {
  font-weight: bold;
  color: #111;
  margin-bottom: 20px;
}
.select-arr {
  display: flex;
  flex-wrap: wrap;
  max-height: 360px;
  overflow-y: scroll;
}
.select-arr .item {
  border: 1px solid #ccc;
  padding: 0 10px;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 10px;
  height: 40px;
}
.el-icon-close {
  padding: 5;
  cursor: pointer;
}
.breadcrumb {
  cursor: pointer;
}
.order-list-search-span:last-child .breadcrumb span {
  display: none;
}
</style>
